import { render, staticRenderFns } from "./BespokeTrevor.vue?vue&type=template&id=1c5dfb88&scoped=true&"
import script from "./BespokeTrevor.vue?vue&type=script&lang=js&"
export * from "./BespokeTrevor.vue?vue&type=script&lang=js&"
import style0 from "./BespokeTrevor.vue?vue&type=style&index=0&id=1c5dfb88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5dfb88",
  null
  
)

export default component.exports